export const BSS_URL = process.env.BSS_URL
export const GOOGLE_API_KEY = process.env.GOOGLE_API_KEY
export const STORAGE_KEY = 'bss'



// WEBPACK FOOTER //
// ./src/constants/index.js